/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactListMembersResult } from '../../models/api-response-contact-list-members-result';
import { ContactListMembers } from '../../models/contact-list-members';

export interface AddContactsToList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ContactListMembers
}

export function addContactsToList(http: HttpClient, rootUrl: string, params: AddContactsToList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactListMembersResult>> {
  const rb = new RequestBuilder(rootUrl, addContactsToList.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactListMembersResult>;
    })
  );
}

addContactsToList.PATH = '/v1/api/ui/contactList/{ref}/contacts';
